import * as types from '../mutation-types'
import dashboard from '../../api/dashboard';

// initial state
const state = {
    loaded: false,
    filterNumber: null,
    location: {
        name: ''
    },
    outlets: [],
    doneOrderItems: [],
}

// getters
const getters = {
    loaded: state => state.loaded,
    location: state => state.location,
    filterNumber: state => state.filterNumber,
    outlets: state => state.outlets,
    doneOrderItems: state => state.doneOrderItems,
}

// actions
const actions = {
    async loadLocation({commit}, locationId) {
        let resp = await dashboard.loadLocation(locationId)
        commit(types.DASHBOARD_LOAD_LOCATION, resp.data)
    },
    async refreshLocation({commit}, locationId) {
        dashboard.refreshLocation(locationId).then((resp) => {
            commit(types.DASHBOARD_LOAD_LOCATION, resp.data)
        }).catch(() => {})
    },
    async ready({commit, state}, data) {
        await dashboard.ready(data.order, data.items);
        let resp = await dashboard.loadLocation(state.location.id)
        commit(types.DASHBOARD_LOAD_LOCATION, resp.data)
    },
    async pickUp({commit, state}, data) {
        await dashboard.pickUp(data.order, data.items);
        let resp = await dashboard.loadLocation(state.location.id)
        commit(types.DASHBOARD_LOAD_LOCATION, resp.data)
    },
    async remind({commit, state}, orderId) {
        await dashboard.remind(orderId);
        let resp = await dashboard.loadLocation(state.location.id)
        commit(types.DASHBOARD_LOAD_LOCATION, resp.data)
    },
    async cancel({commit, state}, data) {
        await dashboard.cancel(data.order, data.items);
        let resp = await dashboard.loadLocation(state.location.id)
        commit(types.DASHBOARD_LOAD_LOCATION, resp.data)
    },
    updateFilterNumber({commit}, number) {
        commit(types.DASHBOARD_FILTER_ORDERS, number)
    },
    updateOutlets({commit}, outlets) {
        commit(types.DASHBOARD_UPDATE_OUTLETS, outlets)
    },
    setOrderItemsDone({commit}, item){
        commit(types.DASHBOARD_SET_ORDER_ITEMS_DONE, item)
    },
    setOrderItemsUndone({commit}, items) {
        commit(types.DASHBOARD_SET_ORDER_ITEMS_UNDONE, items)
    },
    doneOrderItemsContains({state}, items) {
        if (Array.isArray(items)) {
            return items.every(item => state.doneOrderItems.includes(item));
        }
        return state.doneOrderItems.includes(items);
    }
}

// mutations
const mutations = {
    [types.DASHBOARD_FILTER_ORDERS](state, number) {
        state.filterNumber = number
    },
    [types.DASHBOARD_LOAD_LOCATION](state, data) {
        state.loaded = true
        state.location = data
    },
    [types.DASHBOARD_UPDATE_ORDER](state, data) {
        state.loaded = true
        state.location = data
    },
    [types.DASHBOARD_TOGGLE_PAUSED](state) {
        state.paused = !state.paused
    },
    [types.DASHBOARD_UPDATE_OUTLETS](state, data) {
        state.outlets = data
    },
    [types.DASHBOARD_SET_ORDER_ITEMS_DONE](state, item) {
        if (!state.doneOrderItems.find(i => i === item)) {
            state.doneOrderItems.push(item)
        }
    },
    [types.DASHBOARD_SET_ORDER_ITEMS_UNDONE](state, items) {
        if(typeof items === 'number') {
            state.doneOrderItems = state.doneOrderItems.filter(i => i !== items);
        }
        if(Array.isArray(items)) {
            state.doneOrderItems = state.doneOrderItems.filter(i => !items.includes(i))
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
